import { render, staticRenderFns } from "./ChatbotButton.vue?vue&type=template&id=4caae888&"
import script from "./ChatbotButton.vue?vue&type=script&lang=js&"
export * from "./ChatbotButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports